<template>
  <BModal id="buyerContactModal" :visible="show" no-close-on-backdrop :title="title" size="xl" :footer-class="footerClass" @hide="$emit('hide')">
    <div v-if="messaged">
      <Checkmark :title="successMessage" :subtext="successSubtext" />
    </div>
    <div v-else class="row">
      <div v-if="!canSendMessage" class="col-12">
        <BushelAlert alert-class="alert-warning">
          <h5>This feature is currently disabled but will be activated once your account is approved.</h5>
        </BushelAlert>
      </div>
      <div class="col-12" :class="showMockup ? 'col-lg-6' : ''">
        <div class="row">
          <div class="col-12">
            <BushelSelect
              label-active="Buyer Contacts To Email*"
              :options="buyerContacts"
              :value="contactsSelected"
              :multiple="true"
              :loading="!contactsLoaded"
              :disabled="!canSendMessage"
              track-by="id"
              label="name"
              thin
              @select="contactSelectionMade"
              @remove="contactSelectionRemoved"
            />
            <!-- <BushelTextInput
              v-model="myContactName"
              :disabled="!canSendMessage"
              type="text"
              thin
              label-active="My Contact Name"
            />
            <div class="row">
              <BushelTextInput
                v-model="myContactEmail"
                :disabled="!canSendMessage"
                type="text"
                thin
                class="col-12 col-sm-6 col-md-12 col-lg-6"
                label-active="My Contact Email"
              />
              <BushelTextInput
                v-model="myContactPhone"
                :disabled="!canSendMessage"
                type="text"
                thin
                class="col-12 col-sm-6 col-md-12 col-lg-6"
                label-active="My Contact Phone"
              />
            </div> -->

            <BushelTextInput v-model="subject" :disabled="!canSendMessage" type="text" thin label-active="Subject*" class="flex-grow-1" />
            <!-- </div>
      <div class="col-12 col-lg-6"> -->
            <div class="row">
              <div class="col-12 col-sm-6 col-md-12 col-lg-6">
                <BushelTextInput
                  v-model="salutation"
                  :disabled="!canSendMessage"
                  type="text"
                  thin
                  :suffix="appendContactName ? (contactsSelected.length == 1 ? contactsSelected[0].name : '(name added here)') : ''"
                  label-active="Salutation"
                  class="flex-grow-1"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-12 col-lg-6 my-auto mb-auto">
                <div class="custom-checkbox">
                  <input id="appendContactName" v-model="appendContactName" :disabled="!canSendMessage" type="checkbox" />
                  <label for="appendContactName" class="clickable">
                    <span />
                    Add Contact Name
                  </label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-12 col-lg-6 my-auto mb-auto">
                <div class="custom-checkbox">
                  <input id="includeMenuLink" v-model="includeMenuLink" :disabled="!canSendMessage" type="checkbox" />
                  <label for="includeMenuLink" class="clickable">
                    <span />
                    Add Menu Link
                  </label>
                </div>
              </div>
            </div>
            <BushelTextArea v-model="message" :disabled="!canSendMessage" type="text" :rows="10" thin label-active="Message*" class="flex-grow-1" />
          </div>
        </div>
      </div>
      <div v-if="showMockup" class="col-12 col-lg-6">
        <div class="row mt-4">
          <div class="col-12">
            <table class="inner-body" style="width: 100%; max-width: 670px" align="center" cellpadding="0" cellspacing="0" role="presentation">
              <tbody>
                <tr>
                  <td class="content-cell">
                    <!-- <h5 class="text-primary">
                    Subject: {{ subject }}
                  </h5> -->
                    <div style="text-align: center">
                      <div v-if="fromCompany.logoLink && !fromCompany.logoLink.includes('gravatar')" style="padding: 20px" align="center">
                        <div style="padding: 10px">
                          <img :src="fromCompany.logoLink" alt="Logo" style="max-width: 150px" draggable="false" />
                        </div>
                      </div>
                      <div v-else>
                        <h4>{{ fromCompany.name }}</h4>
                      </div>
                    </div>
                    <div
                      style="background-color: #f8f9fa; border-radius: 15px; margin: 10px; padding: 20px; border: 1px solid #e6e6e6"
                      align="center"
                    >
                      <div style="text-align: center">
                        <br />
                        <p v-if="salutation" class="text-primary">
                          {{ salutation
                          }}{{
                            appendContactName ? (contactsSelected.length == 1 ? " " + contactsSelected[0].name : " (name will be added here)") : ""
                          }},
                        </p>
                        <p>{{ message }}</p>
                        <div v-if="includeMenuLink">
                          <p>
                            {{ defaultMenuHelperText }}
                          </p>
                          <BushelBtn v-if="showMenuLink" variant="success">
                            {{ defaultMenuButtonText }}
                          </BushelBtn>
                        </div>
                        <p v-if="myContactName || myContactEmail || myContactPhone" class="mb-2 mt-4">
                          Questions about our products or want to place an order another way? Contact me!
                        </p>
                        <p v-if="myContactName" class="mb-0">
                          {{ myContactName }}
                        </p>
                        <p v-if="myContactEmail" class="mb-0">
                          {{ myContactEmail }}
                        </p>
                        <p v-if="myContactPhone" class="mb-0">
                          {{ myContactPhone }}
                        </p>
                        <br />
                      </div>
                    </div>
                    <!--  <div style="margin: 30px; padding: 20px">
              <div align="center">
                  <img
                    :src="
                      industry == 'cannabis'
                        ? '/img/logos/apex-logo.png'
                        : '/img/logos/bushel-logo.png'
                    "
                    :alt="
                      industry == 'cannabis'
                        ? 'Apex Logo'
                        : 'Bushel44 Logo'
                    "
                    style="max-width: 150px"
                    draggable="false"
                  >
                </div>
                <br>
                <table
                  align="center"
                  cellpadding="0"
                  cellspacing="0"
                  class="social_table"
                  role="presentation"
                  style="
                    table-layout: fixed;
                    vertical-align: top;
                    border-spacing: 0;
                    border-collapse: collapse;
                    mso-table-tspace: 0;
                    mso-table-rspace: 0;
                    mso-table-bspace: 0;
                    mso-table-lspace: 0;
                  "
                  valign="top"
                >
                  <tbody>
                    <tr
                      align="center"
                      style="
                        vertical-align: top;
                        display: inline-block;
                        text-align: center;
                      "
                      valign="top"
                    >
                      <td
                        style="
                          word-break: break-word;
                          vertical-align: top;
                          padding-bottom: 0;
                          padding-right: 4px;
                          padding-left: 4px;
                        "
                        valign="top"
                      >
                        <img
                          alt="Facebook"
                          height="20"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAAk1BMVEUAAABEREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREREQmF3QyAAAAMHRSTlMAAQIDBAgJCgsPEBETFBskJSYvNTZAQUZJWFxfZ2hzdHWCg5SYt77R2uTo6fH19/nX6bMkAAAAvklEQVRYw+3UuRaCMBCF4SAGCYqKigvu+4Y67/90HgtkbARyK4/z17lfN1GqTDUdtJrG166yqN7fXOnduVd1ntzoo7javn0hQoCYCAIiwgA/BYEtYYAhEFigwAkEPD57LKOg4b2qlQa6bH8PLW5gwICJzRGNGWBsgIQBjg0wZYAS4LcAR2etGKDzioCQCkKBIwrsUGCOAkMU6KCAQQEXBFIFAnsUWJc4hqwZ/xOz5EMRQAABBBDgj4HRIe/Lsyf1zMGzcHekewAAAABJRU5ErkJggg=="
                          style="
                              text-decoration: none;
                              -ms-interpolation-mode: bicubic;
                              height: auto;
                              border: none;
                              display: block;
                            "
                          title="Facebook"
                          width="20"
                          draggable="false"
                        >
                      </td>
                      <td
                        style="
                          word-break: break-word;
                          vertical-align: top;
                          padding-bottom: 0;
                          padding-right: 4px;
                          padding-left: 4px;
                        "
                        valign="top"
                      >
                        <img
                          alt="Twitter"
                          height="20"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAABj1BMVEUAAABERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERtoFnfAAAAhHRSTlMAAQIDBAUGBwgJCgsNDg8QERITFBUWFxgaGxwgISQmKCosLS4vMjM3ODo8PURHSk5QUVJUVVZZW1xdXmFjZGZpa2xwcXN1d3h5e3x/gIKDhYiJi4yVl52eoqOlpqiqq62vsLK0tbe5ury+wcXHyNHT1dfZ3ODi5Obo6evt7/Hz9ff5+/3szJufAAACE0lEQVQYGe3B+z9TYQAH4O97toM1IynVKsoUUnLrIummu4yUFJHo4tZkwohZ2/cP72S2nW3nPee8+83n43lw5FCpqL3QEPShRP57v7hv82EAOTrc8Q7QZNCLtLqJOqT167ATWGWetRoA3uYFziPNxwUNcqfjLBBv6Z6m4QTSOsgJARnfFiVu48BXkpMaJJYo8RQGAUOShkUdllop0QtUd47CoHPfag0siHVaG2p/E+NGGQw+pqWuo1iQNuLH8Z/OjPflKNRPub2zSEsyI9EpkG+aUjsnceAbc6JNyLNCmZ9+ZHTQbO2ahpwEJfY0ZB1jvt3n5wUOxCiRhMkwC8WH22oFDHOUSMCkLE4rS2MDXfOU2IRZiMoiyBIAblDVFLIqo+1+tP6lmkFk6SS3JiNU04OcPyxBA3JGWQI/ci5R3TbMolQ2ArMQlTUjzwhV6cijzVLNRxTQZqikCUXuUEFMoJj/ZZJu9aCI1wMReEV3dj0ocoUKulFMbNG13xostNC1Rlgap0sfYE1bpivbZZDwzNCNi5ASfXR2H3aqhlK0Nw4H3vq74Q1KfdfgrDNFmWUPHFXPUmreCycVTyj3SYODM69TlHsEW776x+u0sROCNd+DF8/CY0sJ2hvRISO6dulkLgg7npvbtDN1Dk7E5S+UiPVXwpXytndxFlrsPQUVVY23wp9XYonEZuTH276rdRqOHA7/AM923L/+h9tQAAAAAElFTkSuQmCC"
                          style="
                              text-decoration: none;
                              -ms-interpolation-mode: bicubic;
                              height: auto;
                              border: none;
                              display: block;
                            "
                          title="Twitter"
                          width="20"
                          draggable="false"
                        >
                      </td>
                      <td
                        style="
                          word-break: break-word;
                          vertical-align: top;
                          padding-bottom: 0;
                          padding-right: 4px;
                          padding-left: 4px;
                        "
                        valign="top"
                      >
                        <img
                          alt="Instagram"
                          height="20"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAABsFBMVEUAAABERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERER79KIDAAAAj3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAjJCYnKCorLC0uLzM0Njg5Ojs8Pj9BQ0RFSktNTlFSVFVWV1hZW1xdXmFjZGZoaW9wcXN0dXd4eXt+f4CCg4WGj5KUl5udoqWmqKqrr7CytLW3ubrAw8fKzM/R09fa3N7i5Ojp6+3v8fP19/n7/YJ1gDcAAAPrSURBVFjDnVf5QxJREF5BQRS5BEHIE7XS7NDMoyxLQzvEA1I7rTTPTi01MzBNLVD4l9udebv79u0u7Da/vHkfM+Obed/MWzmOluDNNz/yBWXv7WCI05HKid95Q3I8WaXhbnueNyGv7ax/23HelPzpUPoP5U1LjPa/Lee3NNHfGa0PVnvdLrfH6/X5vF6PoPqD9dHOvvi7I8l0RPZvIdDJXRdXVJy3xWzPi1ApiTpp5QyJZZyc1kaAJGzPLnOGpT0LLs9wV47xrnAmpAN9KmATA33GmKenva5EWOPg9BiwlKBmywz5z/Omu5W8Yj0RvA4EzE3FKiYPwHZXUIdB9fNaN2gBQwFOMPWIkAtofbw2C1dQYsS/hBCgTdj8FbR5XvkiKJ+1rjs6vprKZFIr41ELgb5jAKDbqqBt8coRdaOUOKazMu+z0w4Am2H3CvSEoJ7yCmDD7GFjZ8rWORuBJJt38sejaHILcAtnhbVX6W/fVHffBhJXKlYXoGVcGayXlLMppdW/qUqF0QUAHYTIbYrhJPnvLyaTi/tSBBtthfVwchWwNtH5i+dPuBFwJ8Us6Ms+B5Cbq4K1jvoFeyO/7ZShqh3E7lNmIUB8nAvWWur+sP7LFgUnVvAuHDIUIFxGSlKzPoF/38KwCs8wLSN+0gI+JoAF+JNzssTCVLNy3GoAgqoAOB+n1MzGSkaZE4RIIDlAnBRXJdj240yAWrKGJXxN2Ka1ehH4sMIUMUwCRCQ8LWwXtAIsApmYABESQOZBBiikFQCKkJG2NToBsv8XIKLM1HwKchHXCxdxVVVE7Wt0Gb9Glkit+EyqAyR0iKRD5UrVo6xHZVUzIWW32Gba1msmF1NEriIHyJKynZd12xmPVk8Zj+Lw2KKycG6rP2vEgaIx0r6idW6S3IV7Kqcx0upI12kMVXtaHKPphURiIV14qOJY71SO9bSBsX4RwHLOIr2yRR6WTZvSpps8LBz7yYZ1GMsxT1uMfb8HAefRQ2F9oSJeRZJ+XBMOlcET+IFXPsH5tJ731vj6fjaTXou3WDR+fi/4fROZlzP0gaGQrHjyqyyXjQn20A1ec+m1X2F5SIjIyx5U2W7Ovwxm5z7o+Kk/by7ADDiN4ecAXnm/Gf9recJDaoqxbCwkXTnFdLD+wggvbQbzn0P7w1IRaSCEO40HivPB/0ikKDUDeiXSnn6cG+rpiDZGgoFAoCYYCodDwRpeDYYbox09d2Y/nEqmA3TYXvP/dA0oD9ZwYM79sIlNzTqRM+E/VapRHdu9n8a80zFd2rq7ZjcK/gt7svn0uqfoRVltDqfL4/P7+WvgpSbg9/s8LqfDXmq+6YvLP44/bxWyug2BAAAAAElFTkSuQmCC"
                          style="
                              text-decoration: none;
                              -ms-interpolation-mode: bicubic;
                              height: auto;
                              border: none;
                              display: block;
                            "
                          title="Instagram"
                          width="20"
                          draggable="false"
                        >
                      </td>
                      <td
                        style="
                          word-break: break-word;
                          vertical-align: top;
                          padding-bottom: 0;
                          padding-right: 4px;
                          padding-left: 4px;
                        "
                        valign="top"
                      >
                        <img
                          alt="LinkedIn"
                          height="20"
                          src="data:image/x-icon;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABA0lEQVQ4ja3Uvy5EQRTH8c9dfxoKQraTaDSi0HgHBRGdkhfgGba/CpVKqaaj0fAAKIgCiagkEtlCImKzir1k7myy4d75VeecOfnO/GZOJsMGltBVX7ewmwD0o7whzcl+1YjyOexhNRWwhW0cYjgF8AIdnOMrBXAfk1ipAqPf1gTGMI4XjGCmWGvjE+to4gpneo5KyoP4SO/Vu5jGYpAf4zHIuziJDpXHlrMBbtYwi7egtozNsCkGDtIr5jGFnaBeuu//AE9xp2f1IKg3qwLbQfwexENVgX9SCmDpIZMD48G+x00Rd/CB6yJ/jnovMYqHeIc8LtRQ32DXVoYtLKj/0WZ4+gZbRTCxX8HjUAAAAABJRU5ErkJggg=="
                          style="
                              text-decoration: none;
                              -ms-interpolation-mode: bicubic;
                              height: auto;
                              border: none;
                              display: block;
                            "
                          title="LinkedIn"
                          width="20"
                          draggable="false"
                        >
                      </td>
                      <td
                        style="
                          word-break: break-word;
                          vertical-align: top;
                          padding-bottom: 0;
                          padding-right: 4px;
                          padding-left: 4px;
                        "
                        valign="top"
                      >
                        <img
                          alt="Website"
                          height="20"
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAACJVBMVEUAAABERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERERESf/iXyAAAAtnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTI0NTY3ODk6Ozw9Pj9AQUJDREVGR0lKS0xOT1BRUlRVVldZW1xdXl9hY2RmZ2hrbG1vcHF0dXd4eXt8fn+AgoOFiImLjI6PkZKUlZeam52eoKKjpaaoqqutr7CytLW3ubq+wMHDxcfIyszOz9HT1dfZ2tze4OLk5ujp6+3v8fP19/n7/dGzfBMAAAVJSURBVFjDpZf5X1RVGIe/9w7LwCCyuBAZLqgppmabWaS5JCVmLpm5Z1mkZGgWGbmAe1qhaebCIqAgoDhwZ56/rx/uneGcgUv66fsL57z3fR/Oec/7nrlXClH+0i3HWtsfeU+6/j61591pjp5Hzpwjj7CVuLAq+1nDo/ufpOOekvDSk7OzniU8rz4JJM6dBH6I1dAZ2ZaEjoYBgBvz/nPxn3jAmUVudg/eK1INnVJJHyxWeZ0HNOdNGF/cBsmv8yW1kpypAKC8PkYmS5HaJ+B9MEF8dQKaopK0AVYpDVDxMNckyd2dhCY3LP4w9M/3EzFCiwyA3oH3JEmFN6Bj/G04TXApOKrjJKIWQC089v+xsw/6Jo8XfxG+CcYx2CsbMAnWBk+XegyVjgU0wa7RvSSyMwCqpzdVjeVDDMQy4w8Bu4KoSII6ZQKKYFGw1te7oSujLqv9em0ok6S3oWgMQJdpliR3XS8Av9nn79Fc1ATQtblQf3JTYwFvQo5mNowAtxe9AZ+bCWyjN0sqOQZAZ1ADGYAsuDoAcGWef+Tlo4CPYa4kKXdjFwBDTRsWFOe6AcDJLpix4qs2v7sOlkiS3AfcGW0/j1/Sk9KtcULVODd9L8yHmtFTS5q15fH9tvODGaHDrfu2w0LD7RJDQU3nJvnaeFDo7y4SmzprweKf6F9aVVlWmC0pYiduOnzoj/aAuYBlENE4SZTuctk8uiv0O5LkPOaMad/BPY0PqGPIdKwKUj8b5pv2E/wYAlgLWebhD3Fckr5jxLpy77E1BDAbSkzPejxH0iN+tqoyydIQQAxeNj3nQbmUDytNawReCAG4UG26ZsMmaUnGumJQEAJQgm3WYts4K20BKwXTrUzZgI70leOrgT7pGN2WsRIUBrhCo+VbC65a/TZPawmJUMAZzlm+iyCmdo5YxhX0hwJ+5LrlOwNK1c+hHFOf0WPMdtBtzBrpsnwroVwe/0uz9fT/ASrUwz5rX+voCs3Bd9y1fEtgmv7hqGV8iyehgBNctXwroEgtXFRGk4YCznHS8l0GOfqCwUyqEwb4i3rLdzue9L7d5CqG3DDAAJ9m/BzeksqhwjTmQGkIwIEVFmCQQ5KbtFvMsS4oC5ALc0zXAnhN0h/csLC9fBQCKIdJpudKyJf0kf8nrWa+DwG8m9H5v9MmSXmw0TTv5VYI4Cu7jqJQK0m6Sq9pfxPc8QG37cbdmVp6FSwx7JNhhhSduXrXsdOXevCutPy0v2Z+TIrAcsPPHeJ0MGynwySPcPr44JiuGT5dD+bL1TaYHgxfM14INGXPcHjvHR0tmZxhLqUnrTz1q89Zftv37KmrLi/IclRDpxw3WlK1/bL/4GFt8HL0K8nJZvk2S3LX9wPEGa0EI4m5EAfwvoxKehX22AndpOp+wKt/0Y1zahzAHCgp3j0AJA/mFMRpd+2aoBvoWRORdIhk1ljAEb8KKq8C3kO8Iqt+cweAzlfTJbt+DCDipd4nyloA3pat0mF4KTXppGcMYB3JVJu7d2CnMlWRYGRWMF4OizMATm+6RbKuwWGN1VwPVgfefbRnADakq2jSfTJ+i1IqG4If/NRWp0orBYjG+TVolWH7AE0VdsB9fxvXiUdNwGW8PEnKOQHJNQqT2wj8UuDf+K3OKOAAbJbkbIhD9xRNoDcGgaOl0npodFKArfC7o6zafuBwRBMqUgdw64NJDXAhRzV0yv0WHhQv/DkB3Jyu/1R+XdL/ZoX4jsM8XNkVzODaXD2Tstf+PU4rPz4wVc+u2FsND4zg+PmNZc/3/S5JbkFF1evVyxdXlk703f4vUGg/v87x5ZUAAAAASUVORK5CYII="
                          style="
                              text-decoration: none;
                              -ms-interpolation-mode: bicubic;
                              height: auto;
                              border: none;
                              display: block;
                            "
                          title="Website"
                          width="20"
                          draggable="false"
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br><br>
                <table
                  align="center"
                  cellpadding="0"
                  cellspacing="0"
                  class="social_table"
                  role="presentation"
                  style="
                    table-layout: fixed;
                    vertical-align: top;
                    border-spacing: 0;
                    border-collapse: collapse;
                    mso-table-tspace: 0;
                    mso-table-rspace: 0;
                    mso-table-bspace: 0;
                    mso-table-lspace: 0;
                  "
                  valign="top"
                >
                  <tbody>
                    <tr
                      align="center"
                      style="
                        vertical-align: top;
                        display: inline-block;
                        text-align: center;
                      "
                      valign="top"
                    >
                      <td
                        align="center"
                        style="color: #b4b3b6"
                      >
                        Need Technical Support or have questions about the Platform?
                        <br>
                        <span style="font-size: 13px">
                          <a
                            :href="
                              industry == 'cannabis'
                                ? 'mailto:support@apextrading.com?subject=Technical Support Request for Apex Trading'
                                : 'mailto:support@bushel44.com?subject=Technical Support Request for Bushel44'
                            "
                            target="_blank"
                            style="text-decoration: none; color: #8b7bab"
                          >
                            {{
                              industry == "cannabis"
                                ? "support@apextrading.com"
                                : "support@bushel44.com"
                            }}
                          </a>
                        </span>
                        <br>
                        <a
                          href="tel:1-833-273-9420"
                          target="_blank"
                          style="text-decoration: none; color: #8b7bab"
                        >
                          (833) 273-9420
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <BushelBtn variant="secondary" flat @click="$emit('hide')">
        <span v-if="!messaged">Cancel</span>
        <span v-else>Close</span>
      </BushelBtn>
      <BushelBtn v-if="!messaged" variant="primary" flat @click="showMockup = !showMockup">
        {{ !showMockup ? "Show Mockup" : "Hide Mockup" }}
      </BushelBtn>
      <BushelBtn
        v-if="!messaged"
        variant="success"
        ripple-color="success"
        flat
        :loading="messaging"
        :disabled="submitDisabled || !canSendMessage"
        @click="submit"
      >
        Send
      </BushelBtn>
    </template>
  </BModal>
</template>
<script>
import { mapGetters } from "vuex";
import Checkmark from "@/components/common/Checkmark.vue";
import * as api from "@/services/api";

export default {
  name: "BuyerContactModal",
  components: {
    Checkmark,
  },
  props: {
    show: { type: Boolean, required: true },
    footerClass: { type: String },
    buyerId: { type: Number, required: true },
    buyerUuid: { type: String, default: null },
    buyerLinked: { type: Boolean, required: true },
    user: { type: Object, required: true },
    title: { type: String, default: "Message Buyer" },
    defaultMessage: { type: String, default: "" },
    defaultSubject: { type: String, default: "" },
    defaultSalutation: { type: String, default: "" },
    showMenuLink: { type: Boolean, default: false },
    fromCompany: { type: Object, required: true },
    defaultSuccessMessage: { type: String, default: "Emails Sent" },
    defaultSuccessSubtext: { type: String, default: "" },
    defaultMenuButtonText: { type: String, default: "View Our Menu" },
    defaultIncludeMenuLink: { type: Boolean, default: true },
    defaultMenuContactMeText: { type: String, default: "Questions about our products or want to place an order another way? Contact me!" },
    defaultMenuHelperText: {
      type: String,
      default:
        "Click View Menu and you'll go directly to your personalized menu to order from. Don't worry, you don’t need an account to order and can checkout as a guest with the information we've provided.",
    },
    isProposalLink: { type: Boolean, default: false },
  },
  emits: ["hide", "buyerContacted"],
  data() {
    return {
      appName: APP_NAME,
      industry: APP_INDUSTRY,
      contactsLoaded: false,
      messaged: false,
      messaging: false,
      disableSubmit: false,
      appendContactName: true,
      contactsSelected: [],
      buyerContacts: [],
      subject: this.defaultSubject,
      message: this.defaultMessage,
      showMockup: true,
      myContactName: this.user.name,
      myContactEmail: this.user.company_email ? this.user.company_email : this.user.email,
      myContactPhone:
        this.user.phone && this.user.phone.length == 10
          ? `(${this.user.phone.substr(0, 3)}) ${this.user.phone.substr(3, 3)}-${this.user.phone.substr(6)}`
          : this.user.phone,
      salutation: this.defaultSalutation,
      menuButtonText: this.defaultMenuButtonText,
      menuHelperText: this.defaultMenuHelperText,
      successMessage: this.defaultSuccessMessage,
      successSubtext: this.defaultSuccessSubtext,
      includeMenuLink: this.defaultIncludeMenuLink,
      menuContactMeText: this.defaultMenuContactMeText,
    };
  },
  computed: {
    ...mapGetters({
      currentCompany: "companies/currentCompany",
    }),
    submitDisabled() {
      if (this.message && this.contactsSelected.length && this.subject && !this.messaging) {
        return false;
      }
      return true;
    },
    canSendMessage() {
      return this.fromCompany.approved;
    },
  },
  mounted() {
    this.fetchBuyerContacts();
  },
  methods: {
    fetchBuyerContacts() {
      api.get(`buyer-contacts/${this.buyerId}`).then(
        (response) => {
          this.contactsLoaded = true;
          if (response.data && response.data.data) {
            this.buyerContacts = response.data.data.contacts.filter((contact) => contact.email && !contact.in_marketing_supression_list);
          }
        },
        (error) => {
          //
        },
      );
    },
    contactSelectionMade(selection) {
      if (typeof this.contactsSelected == "undefined") {
        this.contactsSelected = [];
      }
      this.contactsSelected.push(selection);
    },
    contactSelectionRemoved(selection) {
      this.contactsSelected = this.contactsSelected.filter((t) => t != selection);
    },
    submit() {
      if (!this.submitDisabled) {
        this.messaging = true;
        const payload = {
          contacts: this.contactsSelected,
          subject: this.subject,
          message: this.message,
          contactName: this.myContactName,
          contactEmail: this.myContactEmail,
          contactPhone: this.myContactPhone,
          salutation: this.salutation,
          menuButtonText: this.menuButtonText,
          menuHelperText: this.menuHelperText,
          buyerId: this.buyerId,
          includeMenuLink: this.includeMenuLink,
          menuContactMeText: this.menuContactMeText,
          isProposalLink: this.isProposalLink,
          appendContactName: this.appendContactName,
        };
        api.post("buyer-contacts/send-contact-email", payload).then(
          (response) => {
            if (response.data && response.data.message == "emails sent") {
              this.messaging = false;
              this.messaged = true;
              if (response && response.data && response.data.data && response.data.data.contactLogs) {
                this.$emit("buyerContacted", response.data.data.contactLogs);
              }
            }
          },
          (error) => {
            //
          },
        );
      }
    },
    goToBuyerContacts(uuid) {
      this.$router.push({ name: "Buyer", params: { uuid, startingTab: "Contacts" } });
    },
  },
};
</script>

<style scoped></style>
